import { Component } from '@angular/core'
import { AppDownloadComponent } from '@appShared/components/app-download/app-download.component'
import { EXTERNAL_URIS } from '@appShared/external.uris'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'
import { environment } from '@appEnvironments/environment'

@Component({
    selector: 'app-e-order-app',
    imports: [AppDownloadComponent],
    templateUrl: './e-order-app.component.html',
})
export class EOrderAppComponent {
   supportUri = `/${SITE_DIRECTORY_ROUTES.support.uri}`

   private _a4dClientApps = environment.clientApps.a4d
   androidAppUri = this._a4dClientApps.android.download
   androidAppDownloadInstructionsUri = EXTERNAL_URIS.android_app_dowload_instructions.uri
   iosAppUri = this._a4dClientApps.iOS.download
   iOSAppDownloadInstructionsUri = EXTERNAL_URIS.ios_app_dowload_instructions.uri
}
